@let m = meeting();

<!-- Selo do vínculo de origem Cog: sem quem vinculou = o Cog vinculou sozinho; com nome = alguém confirmou a sugestão. -->
<ng-template #seloCog let-link>
  @if (link.linkedByName) {
    <span class="links__cog-badge" title="Sugestão do Cog confirmada por alguém do time">
      <i class="pi pi-sparkles" aria-hidden="true"></i> Cog
    </span>
  } @else {
    <span
      class="links__cog-badge"
      title="O Cog vinculou sozinho, porque a confiança era alta. Se estiver errado, desfaça no X: ele não volta.">
      <i class="pi pi-sparkles" aria-hidden="true"></i> Automático pelo Cog
    </span>
  }
</ng-template>

<ng-template #vinculoManual let-link>
  <li>
    <div class="links__body">
      <strong>{{ rotuloDoVinculo(link) }}</strong>
      <span class="links__muted">
        @if (link.origin === 'Cog') {
          <ng-container *ngTemplateOutlet="seloCog; context: { $implicit: link }" />
        } @else {
          manual
        }
        @if (link.linkedByName) {
          por {{ link.linkedByName }}
        }
        em {{ link.linkedAt | vaultDateTime }}
      </span>
    </div>
    @if (interno()) {
      <button
        type="button"
        class="links__remove"
        [disabled]="ocupada()"
        [title]="'Desfazer o vínculo ' + rotuloDoVinculo(link)"
        [attr.aria-label]="'Desfazer o vínculo ' + rotuloDoVinculo(link)"
        (click)="desvincularVinculo.emit(link)">
        <i class="pi pi-times" aria-hidden="true"></i>
      </button>
    }
  </li>
</ng-template>

<div class="links">
  <!-- O "Vincular" vale para tudo o que a modal cobre, não só deal. -->
  <section class="links__section links__section--top">
    <div class="links__head">
      <div>
        <h4>Vínculos da reunião</h4>
        <span class="links__muted">
          {{ totalDeVinculos() ? totalDeVinculos() + ' vinculado(s)' : 'Nada vinculado ainda' }}
        </span>
      </div>
      @if (interno()) {
        <app-button
          [label]="'Vincular'"
          [icon]="'pi pi-link'"
          [theme]="'outline-grey'"
          [size]="'small'"
          [type]="'button'"
          [disabled]="ocupada()"
          (sendButtonClick)="vincular.emit()" />
      }
    </div>
    @if (interno()) {
      <p class="links__hint">
        Empresas (inclusive as várias de que a reunião tratou), parceiro, deal, deal do pipeline de
        crédito, relacionamento bancário e contato bancário.
      </p>
    }
  </section>

  @if (interno()) {
    <section class="links__group">
      <h5><i class="pi pi-building" aria-hidden="true"></i> Empresas</h5>
      @if (grupos().empresas.length) {
        <ul class="links__list">
          @for (link of grupos().empresas; track link.id) {
            <ng-container *ngTemplateOutlet="vinculoManual; context: { $implicit: link }" />
          }
        </ul>
      } @else {
        <p class="links__muted">Nenhuma empresa vinculada.</p>
      }
    </section>

    @if (grupos().citadas.length) {
      <section class="links__group" aria-label="Empresas citadas na conversa">
        <h5><i class="pi pi-comment" aria-hidden="true"></i> Empresas citadas</h5>
        <p class="links__hint">
          Citadas na conversa sem ser o assunto (exemplo, comparação, de passagem). Ficam ligadas à
          reunião, mas não a abrem para o time.
        </p>
        <ul class="links__list">
          @for (link of grupos().citadas; track link.id) {
            <li>
              <div class="links__body">
                <strong>{{ link.companyName }}</strong>
                <span class="links__muted">
                  <span class="links__cog-badge" title="Registrada pelo Cog ao ler a conversa">
                    <i class="pi pi-sparkles" aria-hidden="true"></i> Cog
                  </span>
                  citada na conversa
                </span>
                @if (link.evidence?.length) {
                  <app-meeting-evidence
                    [evidencias]="link.evidence!"
                    [temVideo]="temVideo()"
                    (irPara)="irPara.emit($event)" />
                }
              </div>
              <button
                type="button"
                class="links__remove"
                [disabled]="ocupada()"
                [title]="'Tirar ' + link.companyName + ' das empresas citadas'"
                [attr.aria-label]="'Tirar ' + link.companyName + ' das empresas citadas'"
                (click)="desvincularVinculo.emit(link)">
                <i class="pi pi-times" aria-hidden="true"></i>
              </button>
            </li>
          }
        </ul>
      </section>
    }

    <section class="links__group">
      <h5><i class="pi pi-users" aria-hidden="true"></i> Parceiros</h5>
      @if (grupos().parceiros.length) {
        <ul class="links__list">
          @for (link of grupos().parceiros; track link.id) {
            <ng-container *ngTemplateOutlet="vinculoManual; context: { $implicit: link }" />
          }
        </ul>
      } @else {
        <p class="links__muted">Nenhum parceiro vinculado.</p>
      }
    </section>
  }

  <section class="links__group">
    <h5><i class="pi pi-briefcase" aria-hidden="true"></i> Deals</h5>
    @if (m.deals.length) {
      <ul class="links__list">
        @for (link of m.deals; track link.dealId) {
          <li>
            <div class="links__body">
              <a [routerLink]="['/dashboard/commercial/my-deals', link.dealId]">{{
                rotuloDoDeal(link)
              }}</a>
              <span class="links__muted">
                {{ rotuloDaEtapa(link.stage) }} ·
                @switch (link.origin) {
                  @case ('Automatic') {
                    automático pelo e-mail dos participantes
                  }
                  @case ('Cog') {
                    <ng-container *ngTemplateOutlet="seloCog; context: { $implicit: link }" />
                  }
                  @default {
                    manual
                  }
                }
                @if (link.linkedByName) {
                  por {{ link.linkedByName }}
                }
              </span>
            </div>
            @if (interno()) {
              <button
                type="button"
                class="links__remove"
                [disabled]="ocupada()"
                [title]="'Desvincular do deal ' + rotuloDoDeal(link)"
                [attr.aria-label]="'Desvincular do deal ' + rotuloDoDeal(link)"
                (click)="desvincularDeal.emit(link)">
                <i class="pi pi-times" aria-hidden="true"></i>
              </button>
            }
          </li>
        }
      </ul>
    } @else {
      <p class="links__muted">Nenhum deal vinculado.</p>
    }
  </section>

  @if (interno()) {
    <section class="links__group">
      <h5><i class="pi pi-building-columns" aria-hidden="true"></i> Relacionamentos bancários</h5>
      @if (grupos().relacionamentos.length) {
        <ul class="links__list">
          @for (link of grupos().relacionamentos; track link.id) {
            <ng-container *ngTemplateOutlet="vinculoManual; context: { $implicit: link }" />
          }
        </ul>
      } @else {
        <p class="links__muted">Nenhum relacionamento bancário vinculado.</p>
      }
    </section>

    <section class="links__group">
      <h5><i class="pi pi-id-card" aria-hidden="true"></i> Contatos bancários</h5>
      @if (grupos().contatos.length) {
        <ul class="links__list">
          @for (link of grupos().contatos; track link.id) {
            <ng-container *ngTemplateOutlet="vinculoManual; context: { $implicit: link }" />
          }
        </ul>
      } @else {
        <p class="links__muted">Nenhum contato bancário vinculado.</p>
      }
    </section>

    <section class="links__group">
      <h5><i class="pi pi-chart-bar" aria-hidden="true"></i> Pipeline de crédito</h5>
      @if (grupos().pipeline.length) {
        <ul class="links__list">
          @for (link of grupos().pipeline; track link.id) {
            <li>
              <div class="links__body">
                @if (link.pipelineDealId) {
                  <a
                    [routerLink]="rotaDoPipeline"
                    [queryParams]="{ dealId: link.pipelineDealId }"
                    [title]="'Abrir o card no Pipeline de crédito'"
                    >{{ rotuloDoDealDoPipeline(link) }}</a
                  >
                } @else {
                  <strong>{{ rotuloDoDealDoPipeline(link) }}</strong>
                }
                <span class="links__muted">
                  @if (link.pipelineName || link.pipelineStageName) {
                    {{ link.pipelineName
                    }}{{ link.pipelineStageName ? ' / ' + link.pipelineStageName : '' }}
                    ·
                  }
                  {{ link.companyName }} ·
                  @if (link.origin === 'Cog') {
                    <ng-container *ngTemplateOutlet="seloCog; context: { $implicit: link }" />
                  } @else {
                    manual
                  }
                  @if (link.linkedByName) {
                    por {{ link.linkedByName }}
                  }
                </span>
              </div>
              <button
                type="button"
                class="links__remove"
                [disabled]="ocupada()"
                [title]="'Desfazer o vínculo ' + rotuloDoVinculo(link)"
                [attr.aria-label]="'Desfazer o vínculo ' + rotuloDoVinculo(link)"
                (click)="desvincularVinculo.emit(link)">
                <i class="pi pi-times" aria-hidden="true"></i>
              </button>
            </li>
          }
        </ul>
      } @else {
        <p class="links__muted">Nenhum deal do pipeline de crédito vinculado.</p>
      }
    </section>

    <section class="links__section links__section--cog" aria-label="Vínculos encontrados pelo Cog">
      <h4><i class="pi pi-sparkles" aria-hidden="true"></i> Encontrados pelo Cog</h4>
      @if (insights()?.enabled !== false) {
        <p class="links__rule">
          <i class="pi pi-info-circle" aria-hidden="true"></i>
          <span>
            O Cog <strong>vincula sozinho</strong> o que encontra com confiança
            {{ limiteAutomatico() ? 'de ' + limiteAutomatico() + ' ou mais' : 'alta' }}. O que fica
            abaixo disso espera você <strong>vincular ou dispensar</strong>. Vínculo automático
            errado? Desfaça no X da lista acima: ele não volta.
          </span>
        </p>
      }
      @switch (situacaoDoCog()) {
        @case ('Pending') {
          <p class="links__soon" aria-live="polite">
            <i class="pi pi-sparkles" aria-hidden="true"></i> O Cog está lendo a conversa para achar
            empresas, bancos, parceiros e deals citados.
          </p>
        }
        @case ('Processing') {
          <p class="links__soon" aria-live="polite">
            <i class="pi pi-sparkles" aria-hidden="true"></i> O Cog está lendo a conversa para achar
            empresas, bancos, parceiros e deals citados.
          </p>
        }
        @case ('Failed') {
          <p class="links__soon" role="alert">
            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i> O Cog não conseguiu
            procurar os vínculos desta reunião. Quando o resumo terminar, peça "Gerar de novo" na
            aba Resumo.
          </p>
        }
        @case ('Skipped') {
          <p class="links__soon">
            O Cog não tinha o que ler nesta reunião: não há transcrição ou ela não tem fala.
          </p>
        }
        @case ('NotStarted') {
          <p class="links__soon">
            @if (insights()?.enabled === false) {
              A sugestão automática de vínculos pelo Cog ainda não está ligada.
            } @else {
              Depois da transcrição, o Cog lê a conversa e sugere os vínculos que faltam: empresas
              citadas, bancos e contatos bancários, parceiros e deals, sempre com o trecho da fala
              que justifica. O que ele encontra com confiança alta já fica vinculado; o resto você
              confirma com um clique.
            }
          </p>
        }
        @default {
          @if (insights(); as i) {
            @if (sugestoes().length) {
              <ul class="links__list">
                @for (sugestao of sugestoes(); track sugestao.id) {
                  <li
                    class="links__suggestion"
                    [class.links__suggestion--applied]="sugestao.status === 'Applied'">
                    <div class="links__body">
                      <span class="links__kind">
                        {{ tipoSugerido(sugestao.kind) }}
                        @if (sugestao.autoApplied) {
                          <span class="links__cog-badge">
                            <i class="pi pi-check" aria-hidden="true"></i> Vinculado automaticamente
                          </span>
                        } @else if (sugestao.status === 'Applied') {
                          <span class="links__cog-badge">
                            <i class="pi pi-check" aria-hidden="true"></i> Vinculado pelo time
                          </span>
                        } @else {
                          <span class="links__cog-badge links__cog-badge--pending">
                            <i class="pi pi-sparkles" aria-hidden="true"></i> Sugerido, falta
                            confirmar
                          </span>
                        }
                      </span>
                      <strong>{{ sugestao.label }}</strong>
                      <span class="links__muted">
                        Confiança {{ confianca(sugestao.confidence) }}
                        @if (ouvidoComo(sugestao); as ouvido) {
                          · ouvido como "{{ ouvido }}"
                        }
                        @if (sugestao.status === 'Suggested' && abaixoDoLimite(sugestao)) {
                          · abaixo de {{ limiteAutomatico() }}, por isso não vinculou sozinho
                        }
                      </span>
                      @if (sugestao.reason) {
                        <span class="links__reason">{{ sugestao.reason }}</span>
                      }
                      @if (sugestao.evidence.length) {
                        <app-meeting-evidence
                          [evidencias]="sugestao.evidence"
                          [temVideo]="temVideo()"
                          (irPara)="irPara.emit($event)" />
                      }
                    </div>
                    @if (sugestao.status === 'Suggested') {
                      <div class="links__decide">
                        <app-button
                          [label]="'Vincular'"
                          [icon]="'pi pi-check'"
                          [size]="'small'"
                          [type]="'button'"
                          [isLoading]="decidindo() === sugestao.id"
                          [disabled]="ocupada() || (!!decidindo() && decidindo() !== sugestao.id)"
                          (sendButtonClick)="confirmarSugestao.emit(sugestao)" />
                        <app-button
                          [label]="'Dispensar'"
                          [theme]="'outline-grey'"
                          [size]="'small'"
                          [type]="'button'"
                          [disabled]="ocupada() || !!decidindo()"
                          (sendButtonClick)="descartarSugestao.emit(sugestao)" />
                      </div>
                    }
                  </li>
                }
              </ul>
            } @else {
              <p class="links__muted">O Cog não achou nada novo para vincular nesta conversa.</p>
            }

            @if (naoVinculados().semCadastro.length) {
              <div class="links__not-found">
                <span class="links__muted">Não encontrei no cadastro:</span>
                <ul>
                  @for (item of naoVinculados().semCadastro; track $index) {
                    <li>
                      <strong>{{ item.mention }}</strong> · {{ motivoDoNaoAchei(item.reason) }}
                      @if (item.triedSpellings.length) {
                        <span class="links__muted">
                          (tentei: {{ item.triedSpellings.join(', ') }})
                        </span>
                      }
                    </li>
                  }
                </ul>
              </div>
            }

            @if (naoVinculados().soCitados.length) {
              <div class="links__not-found">
                <span class="links__muted">Citados, mas sem vínculo:</span>
                <ul>
                  @for (item of naoVinculados().soCitados; track $index) {
                    <li>
                      <strong>{{ item.mention }}</strong> · {{ motivoDoNaoAchei(item.reason) }}
                    </li>
                  }
                </ul>
              </div>
            }

            @if (i.linksExplanation) {
              <div class="links__explanation-box">
                <button
                  type="button"
                  class="links__toggle"
                  [attr.aria-expanded]="explicacaoAberta()"
                  (click)="explicacaoAberta.set(!explicacaoAberta())">
                  <i
                    class="pi"
                    [class.pi-chevron-down]="explicacaoAberta()"
                    [class.pi-chevron-right]="!explicacaoAberta()"
                    aria-hidden="true"></i>
                  Como o Cog chegou nisso
                </button>
                @if (explicacaoAberta()) {
                  <p class="links__explanation">{{ i.linksExplanation }}</p>
                }
              </div>
            }
          }
        }
      }
    </section>
  }
</div>
